import $ from 'jquery';

function checkedValues($checkboxes) {
    return $checkboxes.filter(':checked').map(function () { return $(this).val(); }).get();
}

function init() {
    const $list = $('#ehsManualList');
    if ($list.length === 0) return;

    const $items = $list.find('li');
    const $search = $('#ehsManualSearch');
    const $resultCount = $('#ehsManualResultCount');
    const $noResults = $('#ehsManualNoResults');

    function applyFilters() {
        const selectedCategories = checkedValues($('.ehs-manual-filter-category'));
        const searchText = ($search.val() || '').toLowerCase().trim();

        let visibleCount = 0;

        $items.each(function () {
            const $item = $(this);
            const itemCategories = ($item.data('categories') || '').toString().split(',').filter(Boolean);
            const itemSearch = ($item.data('search') || '').toString();

            const matchesCategories = selectedCategories.length === 0 || selectedCategories.some(c => itemCategories.includes(c));
            const matchesSearch = searchText === '' || itemSearch.includes(searchText);

            const visible = matchesCategories && matchesSearch;
            $item.toggleClass('d-none', !visible);
            if (visible) visibleCount++;
        });

        $resultCount.text(`${visibleCount} result${visibleCount === 1 ? '' : 's'}`);
        $noResults.toggleClass('d-none', visibleCount !== 0);
    }

    $('.ehs-manual-filter-category').on('change', applyFilters);
    $search.on('input', applyFilters);

    $('#ehsManualReset').on('click', function () {
        $('.ehs-manual-filter-category').prop('checked', false);
        $search.val('');
        applyFilters();
    });

    applyFilters();
}

$(document).on('page-init-complete', init);
